import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validator to check if an array is empty
 */
export function nonEmptyArrayValidator(control: AbstractControl): ValidationErrors | null {
    if (Array.isArray(control.value) && control.value.length === 0) {
        return { nonEmptyArray: true };
    }

    return null;
}
